import React from 'react';
export const AutomaticViewerStatus: React.FC<{
  status: 'loading' | 'error';
  errorCode?: string;
  onRetry?: () => void;
}> = ({ status, errorCode, onRetry }) => (
  <div className="gen-file-viewer__media">
    <div
      className="gen-file-viewer__container gen-file-viewer__status"
      role="status"
      aria-live="polite"
      data-preview-state={status}
      data-preview-error={status === 'error' ? errorCode : undefined}
    >
      <div className="gen-file-viewer__status-message">
        {status === 'error' ? 'Не удалось загрузить превью' : 'Загружаем превью…'}
      </div>
      {status === 'error' && onRetry && (
        <button type="button" className="gen-file-viewer__status-retry" onClick={onRetry}>
          Попробовать снова
        </button>
      )}
    </div>
  </div>
);
